package fr.frux.core.database

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class ClusterPyramidCacheQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> select(mapper: (
    id: Long,
    etag: String?,
    payload: String,
    checked_at: Long,
  ) -> T): Query<T> = Query(231_909_033, arrayOf("cluster_pyramid_cache"), driver, "clusterPyramidCache.sq", "select", "SELECT cluster_pyramid_cache.id, cluster_pyramid_cache.etag, cluster_pyramid_cache.payload, cluster_pyramid_cache.checked_at FROM cluster_pyramid_cache WHERE id = 1") { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getString(1),
      cursor.getString(2)!!,
      cursor.getLong(3)!!
    )
  }

  public fun select(): Query<Cluster_pyramid_cache> = select(::Cluster_pyramid_cache)

  /**
   * @return The number of rows updated.
   */
  public fun put(
    etag: String?,
    payload: String,
    checked_at: Long,
  ): QueryResult<Long> {
    val result = driver.execute(1_303_013_506, """
        |INSERT OR REPLACE INTO cluster_pyramid_cache(id, etag, payload, checked_at)
        |VALUES (1, ?, ?, ?)
        """.trimMargin(), 3) {
          var parameterIndex = 0
          bindString(parameterIndex++, etag)
          bindString(parameterIndex++, payload)
          bindLong(parameterIndex++, checked_at)
        }
    notifyQueries(1_303_013_506) { emit ->
      emit("cluster_pyramid_cache")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun touch(checked_at: Long): QueryResult<Long> {
    val result = driver.execute(-1_930_951_694, """UPDATE cluster_pyramid_cache SET checked_at = ? WHERE id = 1""", 1) {
          var parameterIndex = 0
          bindLong(parameterIndex++, checked_at)
        }
    notifyQueries(-1_930_951_694) { emit ->
      emit("cluster_pyramid_cache")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun clear(): QueryResult<Long> {
    val result = driver.execute(-1_946_756_352, """DELETE FROM cluster_pyramid_cache""", 0)
    notifyQueries(-1_946_756_352) { emit ->
      emit("cluster_pyramid_cache")
    }
    return result
  }
}
